import { ColorEnum } from '@/constants/color'
import { ContextMenuProps } from '@/features/orders/components/OrderDetail/parts/Footer/ContextMenu'
import { useScreenLayout } from '@/hooks/screen'
import { FC, ReactElement, ReactNode } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface FooterLayoutProps {
    TopContent?: ReactNode
    children?: ReactNode
    ContextMenu?: ReactElement<ContextMenuProps>
    suppressContextMenuPlaceholderInCompact?: boolean
}

const FooterLayout: FC<FooterLayoutProps> = ({
    TopContent,
    children,
    ContextMenu,
    suppressContextMenuPlaceholderInCompact = false,
}) => {
    const screenLayout = useScreenLayout()

    const withContextMenu = Boolean(ContextMenu)
    const renderContextMenuPlaceholder =
        withContextMenu && (screenLayout === 'extended' || !suppressContextMenuPlaceholderInCompact)

    const { styles } = useStyles(stylesheet, { withContextMenu })

    return (
        <View style={styles.container}>
            {TopContent}
            <View style={styles.contentRow}>
                {renderContextMenuPlaceholder && <View style={styles.placeholder} />}
                {children}
                {withContextMenu && ContextMenu}
            </View>
        </View>
    )
}

const stylesheet = createStyleSheet((_, { insets }) => ({
    container: {
        alignSelf: 'stretch',
        backgroundColor: ColorEnum.GRAY_100,
        borderTopStartRadius: 16,
        borderTopEndRadius: 16,
        paddingHorizontal: 16,
        paddingTop: 16,
        paddingBottom: 16 + insets.bottom,
        gap: 16,
    },
    contentRow: {
        gap: 16,
        variants: {
            withContextMenu: {
                false: {
                    alignSelf: 'stretch',
                    alignItems: 'center',
                },
                true: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                },
            },
        },
    },
    placeholder: {
        width: 44,
        height: 44,
    },
}))

export default FooterLayout
